export default "__VITE_ASSET__b2d30dcf__"